import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";
import { getParameterByName } from "../router.service";

export function deCodeTokenData() {
  const token =
    getParameterByName("code") || Cookies.get("mykiot_access_token") || localStorage.getItem("mykiot_access_token");
  if (!token) {
    return {};
  }
  try {
    const decodeToken: IDecodeToken = jwtDecode(token);
    return decodeToken;
  } catch (error) {
    return {};
  }
}
